import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const SQUARE_APP_ID = process.env.REACT_APP_SQUARE_APPLICATION_ID || "";
export const SQUARE_LOCATION_ID = process.env.REACT_APP_SQUARE_LOCATION_ID || "";
export const SQUARE_ENV = process.env.REACT_APP_SQUARE_ENV || "sandbox";
export const SQUARE_ENABLED = Boolean(SQUARE_APP_ID && SQUARE_LOCATION_ID);

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const formatCAD = (cents) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format((cents || 0) / 100);

// Uploaded images are stored as backend-relative paths (/api/files/...). Make them absolute.
export const resolveImg = (url) => (url && url.startsWith("/") ? `${BACKEND_URL}${url}` : url);

export default api;
